const Router = {
  // Services
  SERVICES: "/services",
  SERVICES_UPLOAD: "/services/upload",
  // Skills
  SKILLS: "/skills",
  SKILLS_UPLOAD: "/skills/upload",
  // Works
  WORKS: "/works",
  WORKS_UPLOAD: "/works/upload",
  // Auth
  LOGIN: "/login",
  // Admin
  ADMIN: "/admin",
  ADMIN_WORKS: "/admin/works",
  ADMIN_SKILLS: "/admin/skills",
  ADMIN_SERVICES: "/admin/services",
  // General
  HOME: "/",
  NOT_FOUND: "*",
};

export default Router;
